import AvailabilitySlot from './slot';

export type { AvailabilitySlotProps } from './slot';

export default AvailabilitySlot;
